import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { FuelFill } from '../types/fuel-fill';

@Component({
  selector: 'fuel-fill-edit',
  template: `<div class="editrow">
  <mat-form-field class="fill_timestamp">
    <input #fill_timestamp placeholder="The date & time of this fill" matInput [(ngModel)]="fill.fill_timestamp" (ngModelChange)="changed()" />
  </mat-form-field>
  <mat-form-field class="number">
    <input #fill_amount placeholder="The amount, in litres, of this fuel fill."
         matInput [(ngModel)]="fill.fill_amount" (ngModelChange)="changed()">
  </mat-form-field>
  <mat-checkbox #tank_filled labelPosition="after" class="boolean"
                [(ngModel)]="fill.tank_filled" (ngModelChange)="changed()">Tank was filled</mat-checkbox>
  <div class="panel">
    <button mat-raised-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!hasChanges || !isValid()">Save</button>
  </div>
</div>
<div class="editrow">
  <p class="error" *ngFor="let error of errorMessages">{{error}}</p>
</div>
`,
  styles: [
    `.panel {display: inline-block; position: relative; bottom: 0.5em; left: 0.5em;}`,
    `.editrow {vertical-align: middle; display: block;}`,
    `.boolean {padding-left: 1em;}`,
    `.number {width: 7em; margin-left: 2em; text-align: right;}`,
    `.ip {width: 10em;}`,
    `.version { width: 15em; margin-left: 2em; }`,
    `p.error { color: #800000; padding: 0.1em 1em; margin: 0; white-space: pre-line; }`,
  ],
  providers: [ HubService ],
})

export class FuelFillEditComponent implements OnInit {
  @Input() inFill: FuelFill;
  @Output() fillSaved = new EventEmitter<boolean>();
  fill: FuelFill;
  hasChanges = false;
  errorMessages: string[];

  constructor(
    private hubService: HubService,
  ) {
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    if (!this.inFill) { this.inFill = new FuelFill(); }
    this.fill = Object.assign({}, this.inFill);  // Clone
  }

  isValid(): boolean {
    this.errorMessages = <string[]>[];
    if (this.hasChanges) {
      if (!this.fill.hubid) {
        this.errorMessages.push('Hub ID must be set.');
      }
      if (!this.fill.fill_amount) {
        this.errorMessages.push('Fill amount must be set.');
      }
      if (!this.fill.fill_timestamp) {
        this.errorMessages.push('Fill timestamp must be set.');
      }
      if (this.errorMessages.length) {
        for(let i=0; i<this.errorMessages.length; i++ ) {
          console.log(this.errorMessages[i]);
        }
        return false;
      }
    }
    return true;
  }

  changed() {
    this.hasChanges = true;
  }

  cancel(): void {
    this.fillSaved.emit(false);
  }

  save(): void {
    this.fill.hubid = Number(this.inFill.hubid);
    this.fill.fill_amount = Number(this.fill.fill_amount);
    this.errorMessages = <string[]>[];
    this.hubService.writeFuelFill(this.fill)
      .subscribe(
        () => {
          this.inFill = this.fill;
          this.fillSaved.emit(true);
          this.hasChanges = false;
        },
        (e: any) => this.errorMessages.push(e as string)
      );
  }
}
